import { Card } from "@/shared/ui/card";
import FeatureGrid from "./FeatureGrid";
import { motion } from "motion/react";
import { ImageCarousel } from "./AutoCarousel";

const Information = () => {
  return (
    <div className="min-h-screen w-full relative z-40">
      <div className='flex w-full flex-col items-center px-5 justify-center gap-5 lg:gap-10 bg-[#2A0163] pt-8 md:pt-16 xl:pt-28 relative'>
        <h3 className="font-montserrat text-2xl text-gray-50 sm:text-4xl lg:text-5xl leading-6 tracking-wide text-center">
          Every brand has a voice.<br />
          Few keep it alive.</h3>
        <FeatureGrid />
        <div className="w-full flex flex-col gap-5 md:gap-10 items-center justify-center py-5 md:pt-10 xl:pt-24 -mb-48">
          <h3 className="text-2xl lg:text-5xl font-montserrat text-white">Real customers engage with authentic brands.</h3>
          <p className="font-poppins max-w-5xl tracking-wide leading-6 text-gray-200 text-center text-sm sm:text-base lg:text-lg">siAi isn't here to just write faster. She's here to think deeper. She learns your brand's DNA - your language, tone, and rhythm - and creates content that sounds unmistakably you.</p>
          <ImageCarousel />
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.6,
              delay: 4,
              ease: "easeOut",
            }}
            className="w-full max-w-5xl mx-auto py-10 hidden md:grid md:grid-cols-3 min-h-[30rem] gap-4 p-6">
            <Card className="border-0 ring-0 overflow-hidden">
              <img src="https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9Filows2734notj1daOZW8ixGuckNIgXvfRPp" className="w-full h-full object-cover" />
            </Card>
            <Card className="border-0 ring-0 overflow-hidden">
              <img src="https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9pp0jzeEfqR83wQxCZB9mau0bU4YJrXgLH1Wl" className="w-full h-full object-cover" />
            </Card>
            <Card className="border-0 ring-0 overflow-hidden">
              <img src="https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9mTC79P8BESupc3KwDzo4tbeGVHYWUAdQyl5j" className="w-full h-full object-cover" />
            </Card>
          </motion.div>
        </div>

      </div>
    </div>
  )
}

export default Information
